<template>
    <div class="relative w-full px-3 xxs:py-4 border-b border-px border-interactive-9 hover:bg-background-3" :class="[size === 'small' ? 'lg:py-4' : 'lg:py-5']">
        <div class="flex flex-row items-center text-default-1 text-body-6 cursor-pointer" :class="!isRead && item.sent_at !==  null && 'font-medium'">
            <Checkbox v-if="layout === 'inbox'" :model-value="isOptionSelected" @update:model-value="$emit('update:model-value', item.uid)"/>
            <p class="flex-1 overflow-hidden overflow-ellipsis max-h-[60px] multi-line-ellipsis clamp-1-line ml-2 lg:mr-4" @click="$emit('clicked')">{{sanitizedBody}}</p>
            <p v-if="item.sent_at ===  null && item.scheduled_at !== null" class="mr-1">Scheduled</p>
            <p class="text-right" @click="$emit('clicked')">
                {{formattedDate}}
            </p>
        </div>
    </div>
</template>
<script setup>
import {computed, defineProps} from "vue";
import Checkbox from "@/components/core/Checkbox.vue";
import moment from "moment";
import {useDomPurifier} from "@/composables/useDomPurifier";

const props = defineProps({
    item: {
        type: Object,
        default: () => {},
        required: true,
    },
    selectedItems: {
        type: Array,
        default: () => [],
    },
    layout: {
        type: String,
        default: 'inbox',
        required: true
    },
    size: {
        type: String,
        default: 'small',
        required: false
    }
});

const emit = defineEmits(['clicked', 'update:model-value']);

const isRead = computed(() => {
    return (typeof props.item.read_at === 'string');
});

const formattedDate = computed(() => {
    if(props.item.draft)
        return moment(props.item.created_at).format('MM/DD/YY');
    else if('sent_at' in props.item && props.item.sent_at !== null)
        return moment(props.item.sent_at).format('MM/DD/YY');
    else if('scheduled_at' in props.item && props.item.scheduled_at !== null)
        return moment(props.item.scheduled_at).format('MM/DD/YY for HH:mm');

    return moment(props.item.created_at).format('MM/DD/YY');
});


const isOptionSelected = computed(() => {
    return props.selectedItems.filter(selected => selected === props.item.uid).length > 0
})

const smsData = computed(() => {
    return props.item.sms ? props.item.sms : props.item
})

const sanitizedBody = computed(() => {
    return useDomPurifier(smsData.value.body);
});
</script>